module.exports = __webpack_public_path__ + "assets/htu-4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/HTU-modal/htu-4.jpg
// module id = 1191
// module chunks = 7